import { computed } from 'vue'
import { useAuth } from './useAuth'
import { calculateMaxPensionAndTaxback } from '@/lib/utils/calculate-pension'
import { useTaxbackCredits } from './useTaxbackCredits'

export function usePensionCalculations() {
  const { user } = useAuth()
  const { totalTaxbackCredits } = useTaxbackCredits()

  const calculatedValues = computed(() => {
    return calculateMaxPensionAndTaxback({ user: user.value })
  })

  const pension = computed(() => calculatedValues.value.pension)
  const maxPension = computed(() => calculatedValues.value.maxPension)
  const taxback = computed(() => calculatedValues.value.taxback)
  const maxTaxback = computed(() => calculatedValues.value.maxTaxback)
  const credits = computed(() => (user?.value?.taxback ?? 0) / 100)

  return {
    pension,
    maxPension,
    taxback,
    maxTaxback,
    credits,
    totalTaxbackCredits,
  }
}
